import { apiPost } from "./apiClient";

// Emails a client a signed link to pay one invoice. The link carries the
// invoice and its own expiry, so nothing needs to be stored to make it work —
// what the API records is when it was sent, which is the column admins see.
export async function sendInvoicePaymentLink(
  invoiceId: string,
  recipients?: string[],
  to?: string,
) {
  return apiPost({
    endpoint: "/send-invoice-payment-link",
    data: {
      invoiceId,
      ...(recipients?.length ? { recipients } : {}),
      ...(to ? { to } : {}),
    },
    withAuth: true,
  });
}

// Everyone a link for this invoice could go to: the address on the customer
// record, and the portal users whose projects include that customer.
export type InvoiceLinkRecipient = {
  id?: string;
  name: string;
  email: string;
  role?: string;
  onRecord?: boolean;
};

export async function getInvoiceLinkRecipients(invoiceId: string): Promise<{
  invoiceId: string;
  invoiceNumber?: string;
  customerName?: string;
  recipients: InvoiceLinkRecipient[];
}> {
  return apiPost({
    endpoint: "/get-invoice-link-recipients",
    data: { invoiceId },
    withAuth: true,
  });
}
